var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg001Home(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.2,236.7h0S303.3,27.8,303.3,27.8c-8.9-8.9-20.7-13.8-33.3-13.8s-24.4,4.9-33.3,13.8L27.9,236.6c0,0-.1.1-.2.2-18.3,18.4-18.2,48.2,0,66.6,8.4,8.4,19.4,13.2,31.3,13.7.5,0,1,0,1.5,0h8.3v153.7c0,30.4,24.7,55.2,55.2,55.2h81.7c8.3,0,15-6.7,15-15v-120.5c0-13.9,11.3-25.2,25.2-25.2h48.2c13.9,0,25.2,11.3,25.2,25.2v120.5c0,8.3,6.7,15,15,15h81.7c30.4,0,55.2-24.7,55.2-55.2v-153.7h7.7c12.6,0,24.4-4.9,33.3-13.8,18.4-18.4,18.4-48.3,0-66.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001Home);
export default __webpack_public_path__ + "static/media/001-home.036dd93214505ade739d3b6443cc1f6a.svg";
export { ForwardRef as ReactComponent };